import React from "react";

const FormSelect = ({
  label,
  name,
  options = [],
  placeholder = "Select an option",
  required = false,
  className = "",
  register,
  error,
  ...rest
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-[#636363] mb-1">
          {label}{required && <span className="text-red-500">*</span>}
        </label>
      )}

      <select
        id={name}
        name={name}
        required={required}
        className="w-full rounded-md border border-[#CACACA] bg-[#F6F6F6] pl-2 py-2 text-sm text-[#1100EF] focus:text-[#000] placeholder:text-[#858585] focus:outline-none focus:ring-2 focus:ring-blue-500"
        {...register(name)}
        {...rest}
      >
        <option value="" disabled hidden>{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <p className="text-sm text-red-500 mt-1">{error.message}</p>}
    </div>
  );
};

export default FormSelect;
